import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { AppliedJobConstant } from 'src/app/constants/label-constants';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-job-view',
  templateUrl: './job-view.component.html',
  styleUrls: ['./job-view.component.scss']
})
export class jobViewComponent {
  JobApplyForm: FormGroup = this.formBuilder.group({});
  JobApplyId: number = 0;
  Title: string = '';
  JobApplyList: any = [];
  cancel: string = CommonConstant.CANCEL;
  CommonConstant: any = [];
  AppliedJobConstant: any = [];
  flag: boolean = false;
  constructor(
    private CommonService: CommonService,
    private apiUrl: ApiUrlHelper,
    public modalService: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.CommonConstant = CommonConstant;
    this.AppliedJobConstant = AppliedJobConstant;
    this.getAppliedJobDetail(this.JobApplyId);
  }

  getAppliedJobDetail(JobApplyId: number) {
    const apiUrl = this.apiUrl.apiUrl.job.AppliedJob.replace("{jobapplyid}", JobApplyId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data.data) {
          this.JobApplyList = data.data;
          this.Title = this.JobApplyList.title;
        }
        this.spinner.hide();
        this.flag = true;
      },
      error: (err) => {
        console.log('getAppliedJobDetail-Error', err);
      }
    });
  }

  DownloadResume(url: string) {
    this.CommonService.doDownload(url, true).subscribe(response => {
      const a = document.createElement('a');
      let blob: Blob = response.body!;
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = this.extractFileName(url); // Desired file name for the downloaded image
      // Programmatically click the anchor element to initiate the download
      document.body.appendChild(a);
      a.click();
      // Clean up after download
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    });
  }
  
  extractFileName(url: string | undefined): string {
    if (!url) {
      // throw new Error('URL is undefined.');
      return ''
    }
    const parsedUrl = new URL(url);
    return parsedUrl.pathname.split('/').pop() || ''; // Return empty string if filename is not found
  }
}
